var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMicrophoneFilled = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "var(--text1-color)",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5a3.734 3.734 0 0 0 3.738-3.75l.012-7.5A3.745 3.745 0 0 0 9 .5a3.745 3.745 0 0 0-3.75 3.75v7.5A3.745 3.745 0 0 0 9 15.5Zm6.625-3.75c0 3.75-3.175 6.375-6.625 6.375S2.375 15.5 2.375 11.75H.25c0 4.262 3.4 7.788 7.5 8.4v4.1h2.5v-4.1c4.1-.6 7.5-4.125 7.5-8.4h-2.125Z"
  })));
};
export { SvgMicrophoneFilled as ReactComponent };